/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// @ts-ignore
import { exists, mapValues } from '../runtime';
// @ts-ignore
import type { Retailer } from './Retailer';
// @ts-ignore
import {
// @ts-ignore
    RetailerFromJSON,
// @ts-ignore
    RetailerFromJSONTyped,
// @ts-ignore
    RetailerToJSON,
} from './Retailer';

/**
 * 
 * @export
 * @interface RetailerListResponse
 */
export interface RetailerListResponse {
    /**
     * 
     * @type {number}
     * @memberof RetailerListResponse
     */
    totalCount?: number;
    /**
     * 
     * @type {number}
     * @memberof RetailerListResponse
     */
    estimatedTotalCount: number;
    /**
     * 
     * @type {Array<Retailer>}
     * @memberof RetailerListResponse
     */
    items: Array<Retailer>;
}

/**
 * Check if a given object implements the RetailerListResponse interface.
 */
// @ts-ignore
export function instanceOfRetailerListResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "estimatedTotalCount" in value;
    isInstance = isInstance && "items" in value;

    return isInstance;
}

// @ts-ignore
export function RetailerListResponseFromJSON(json: any): RetailerListResponse {
    return RetailerListResponseFromJSONTyped(json, false);
}

// @ts-ignore
export function RetailerListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RetailerListResponse {
// @ts-ignore
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'total_count') ? undefined : json['total_count'],
        'estimatedTotalCount': json['estimated_total_count'],
        'items': ((json['items'] as Array<any>).map(RetailerFromJSON)),
    };
}

// @ts-ignore
export function RetailerListResponseToJSON(value?: RetailerListResponse | null): any {
// @ts-ignore
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'total_count': value.totalCount,
        'estimated_total_count': value.estimatedTotalCount,
        'items': ((value.items as Array<any>).map(RetailerToJSON)),
    };
}

